"use client"
import { useSelector } from 'react-redux'
import { Title, } from '@/components'
import { TopProducts } from '@/components'

const TopSaleProducts = () => {

  const { allProducts, isLoader } = useSelector((state) => state.allproducts)
  // console.log("all products", allProducts)
  const filteredProducts = allProducts?.filter((item) =>
    item?.topSale == true
  );
  // console.log("top  sale products",filteredProducts)
  return (
    <>
      <Title title={`Top Selling Products`} />
      <TopProducts filterData={filteredProducts} />
    </>
  )
}

export default TopSaleProducts